import React from 'react'
import { Col, Row } from 'antd'
import { Color } from '../../Common/Color'
import { t } from 'i18next'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'

export default function ErrorPage ({ error, name }) {
  const screens = useBreakpoint()

  const xsDisplay = <Row style={{ background: 'linear-gradient(white, teal, white)', height: '90vh' }}>
    <Col span={1} />
    <Col span={22} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
      <div style={{ backgroundColor: '#fff', borderRadius: '0 30px 30px 0' }}>
        <div className="contentPadding" style={cssTitle}>
          {t(`Public.ErrorPage.${error}.title`)}
        </div>
        <div className="contentPadding" style={{ fontSize: '18px', maxWidth: '1200px', margin: '2.5em 0' }}>
          {t(`Public.ErrorPage.${error}.description`, { name })}
        </div>
      </div>
    </Col>
    <Col span={1} />
  </Row>

  const xlDisplay = <Row style={{ background: 'linear-gradient(white, teal, white)', height: '90vh' }}>
    <Col span={8} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
      <div style={{ backgroundColor: '#fff', borderRadius: '0 30px 30px 0' }}>
        <div className="contentPadding" style={cssTitle}>
          {t(`Public.ErrorPage.${error}.title`)}
        </div>
        <div className="contentPadding" style={{ fontSize: '18px', maxWidth: '1200px', margin: '2.5em 0' }}>
          {t(`Public.ErrorPage.${error}.description`, { name })}
        </div>
      </div>
    </Col>
    <Col span={16}>
      <img style={{}} src="/images/box-exterieur.png" title="Image de la Box Médicale extérieur" height={400} />
    </Col>
  </Row>

  return (
    <div style={{ gap: '1em', height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: Color.white }}>
      {screens.xs ? xsDisplay : xlDisplay }
    </div>
  )
}
const cssTitle = {
  fontSize: '30px',
  fontWeight: 'bold',
  borderWidth: '2px 2px 2px 0px',
  borderStyle: 'solid',
  borderRadius: '0px 30px 30px 0px',
  display: 'inline-block',
  margin: '0.5em 0'
}
